import { render, staticRenderFns } from "./TemplateModal.vue?vue&type=template&id=55783cf0"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports